module.exports = __webpack_public_path__ + "img/Apoptosis-LICA_PLC.b5969f2c.png";